import { RouteRecordRaw } from "vue-router";

import { OffersAndStoreHome } from "@/pages/OffersAndStore";

import links from "./links";

import DummyRouterView from "@/components/structure/DummyRouterView.vue";
import ItemsList from "@/modules/Items";
import { CampaignsList, OfferDetails, OffersList, OffersListV2 } from "@/modules/Offers";
import RewardsList from "@/modules/Rewards";
import Store from "@/modules/Store";
import CreateCampaign from "@/pages/OffersAndStore/OfferCampaigns/CreateCampaign.vue";

export default <RouteRecordRaw[]>[
  {
    path: "",
    component: OffersAndStoreHome,
    name: links.offersAndStore.offersAndStoreHome,
    meta: {
      title: "Offers And Store",
    },
    children: [
      {
        path: "",
        redirect: { name: links.offersAndStore.tabs.items },
      },
      {
        path: "offers",
        component: OffersList,
        name: links.offersAndStore.tabs.offers,
        meta: {
          title: "Offers",
        },
      },
      {
        path: "offer-campaigns",
        component: DummyRouterView,
        redirect: { name: links.offersAndStore.tabs.offerCampaigns.campaignList },
        children: [
          {
            path: "",
            component: CampaignsList,
            name: links.offersAndStore.tabs.offerCampaigns.campaignList,
            meta: {
              title: "Campaign List",
            },
            props: true,
          },
          {
            path: "new-campaign",
            component: CreateCampaign,
            name: links.offersAndStore.tabs.offerCampaigns.createCampaign,
            meta: {
              title: "New Campaign",
            },
            props: true,
          },
          {
            path: ":campaignId",
            component: OffersListV2,
            name: links.offersAndStore.tabs.offerCampaigns.offerList,
            meta: {
              title: "Offer List",
            },
            props: true,
          },
          {
            path: ":campaignId/offer/:offerId",
            component: OfferDetails,
            name: links.offersAndStore.tabs.offerCampaigns.offerDetails,
            meta: {
              title: "Offer Details",
            },
            props: true,
          },
        ],
      },
      {
        path: "items",
        component: ItemsList,
        name: links.offersAndStore.tabs.items,
        meta: {
          title: "Offers",
        },
      },
      {
        path: "rewards",
        component: RewardsList,
        name: links.offersAndStore.tabs.rewards,
        meta: {
          title: "Rewards",
        },
      },
      {
        path: "store",
        component: Store,
        name: links.offersAndStore.tabs.store,
        meta: {
          title: "Store",
        },
      },
    ],
  },
];
